import styled from 'styled-components';
import {
  v2Colors, v2FontFamily, v2ReadableFontFamily,
} from './styles/tokens';

export const WarningAlert = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
  padding: 10px 14px;
  border: 1px solid ${v2Colors.warningBorder};
  border-radius: 12px;
  background-color: ${v2Colors.warningSoft};
  font-family: ${v2ReadableFontFamily};
  font-size: 13px;
  line-height: 1.5;
  color: ${v2Colors.warningText};

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: ${v2Colors.warning};
  }

  strong {
    font-family: ${v2FontFamily};
    font-weight: 700;
  }
`;
